module.exports = __webpack_public_path__ + "img/img_006-75x75-2.ceee60e8.png";